var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("表单编辑"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 1200
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [!_vm.isEdit ? _c("div", {
    staticClass: "leftBox"
  }, [_c("a-button", {
    staticStyle: {
      padding: "0"
    },
    attrs: {
      type: "link"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("点击选择控件进行编辑")) + " ")]), _c("div", {
    staticClass: "itemBox"
  }, [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("统计字段")))])]), _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.statistics, function (item) {
    return _c("div", {
      key: item.id,
      on: {
        click: function ($event) {
          return _vm.controlItemFun(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " "), _c("a-icon", {
      attrs: {
        type: item.icon
      }
    })], 1);
  }), 0)], 1), _c("div", {
    staticClass: "itemBox"
  }, [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("控件")))])]), _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.control, function (item) {
    return _c("div", {
      key: item.id,
      on: {
        click: function ($event) {
          return _vm.controlItemFun(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " "), _c("a-icon", {
      attrs: {
        type: item.icon
      }
    })], 1);
  }), 0)], 1), _c("div", {
    staticClass: "itemBox"
  }, [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("控件组")))])]), _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.controlGroup, function (item) {
    return _c("div", {
      key: item.id,
      on: {
        click: function ($event) {
          return _vm.controlGroupFun(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " "), item.icon ? _c("a-icon", {
      attrs: {
        type: item.icon
      }
    }) : _vm._e()], 1);
  }), 0)], 1)], 1) : _c("div", {
    staticClass: "leftBox"
  }, [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t(_vm.controlTitle)))])]), _vm.controlType == "control" ? _c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.dataForm,
      rules: _vm.dataRules,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 15
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("表单区名称")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 15,
      disabled: _vm.dataForm.statistical && _vm.dataForm.statistical == "amount"
    },
    model: {
      value: _vm.dataForm.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "controlName", $$v);
      },
      expression: "dataForm.controlName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataForm.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "controlExplain", $$v);
      },
      expression: "dataForm.controlExplain"
    }
  })], 1), _vm.dataForm.partsType != "date" && _vm.dataForm.partsType != "dateRange" && _vm.dataForm.partsType != "picture" && _vm.dataForm.partsType != "enclosure" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示文字")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataForm.promptText,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "promptText", $$v);
      },
      expression: "dataForm.promptText"
    }
  })], 1) : _vm._e(), _vm.dataRules.option ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选项"),
      prop: "option"
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请填写") + _vm.$t("控件选项，不同选项用“;”隔开(英文)")
    },
    on: {
      blur: _vm.textareaList
    },
    model: {
      value: _vm.dataForm.option,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "option", $$v);
      },
      expression: "dataForm.option"
    }
  })], 1) : _vm._e(), _vm.dataRules.type ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选择类别"),
      prop: "type"
    }
  }, [_c("a-radio-group", {
    staticStyle: {
      display: "flex",
      "flex-direction": "column"
    },
    model: {
      value: _vm.dataForm.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "type", $$v);
      },
      expression: "dataForm.type"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "country"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("国家")) + " ")]), _c("a-radio", {
    attrs: {
      value: "province"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("省市区")) + " ")]), _c("a-radio", {
    attrs: {
      value: "area"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("地区代码")) + " ")])], 1)], 1) : _vm._e(), _vm.dataRules.dateType ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("日期类型"),
      prop: "dateType"
    }
  }, [_c("a-radio-group", {
    staticStyle: {
      display: "flex",
      "flex-direction": "column"
    },
    model: {
      value: _vm.dataForm.dateType,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "dateType", $$v);
      },
      expression: "dataForm.dateType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("年-月-日")) + " ")]), _c("a-radio", {
    attrs: {
      value: 3
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("年-月-日 时：分：秒")) + " ")])], 1)], 1) : _vm._e(), _vm.dataForm.partsType == "picture" || _vm.dataForm.partsType == "enclosure" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件格式"),
      prop: "fileFormat"
    }
  }, [_c("div", [_c("a-checkbox", {
    attrs: {
      indeterminate: _vm.indeterminate,
      checked: _vm.checkAll
    },
    on: {
      change: _vm.onCheckAllChange
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("全选")) + " ")])], 1), _c("a-checkbox-group", {
    attrs: {
      options: _vm.plainOptions
    },
    on: {
      change: _vm.onChangeFormat
    },
    model: {
      value: _vm.dataForm.fileFormat,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "fileFormat", $$v);
      },
      expression: "dataForm.fileFormat"
    }
  })], 1) : _vm._e(), _vm.dataForm.partsType == "picture" || _vm.dataForm.partsType == "enclosure" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("模板"),
      prop: "template"
    }
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      accept: _vm.uploadAccept,
      remove: _vm.removeUploadFile,
      "open-file-dialog-on-click": _vm.fileDialog,
      "file-list": _vm.dataForm.template || [],
      "list-type": "picture-card",
      data: {
        module: "auditAttachment"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      preview: _vm.handlePreview,
      change: _vm.changeUpload
    }
  }, [_c("div", {
    staticClass: "upload-icon",
    on: {
      click: _vm.clickPlus
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  })], 1)])], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("其他")
    }
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.checked
    },
    on: {
      change: _vm.otherChangeFun
    }
  }, [_vm._v(_vm._s(_vm.$t("必填")))])], 1), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 4
      }
    }
  }, [_c("a-button", {
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")]), _c("a-button", {
    staticClass: "marginL15",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("确认")) + " ")])], 1)], 1) : _vm._e(), _vm.controlType == "controlGroup" || _vm.controlType == "table" ? _c("a-form-model", {
    ref: "ruleGroupForm",
    attrs: {
      model: _vm.dataGroupForm,
      rules: _vm.dataGroupRules,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 15
      }
    }
  }, [_vm.controlType == "controlGroup" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("其他")
    }
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.checked
    },
    on: {
      change: _vm.otherChangeFun
    }
  }, [_vm._v(_vm._s(_vm.$t("允许添加多个")))])], 1) : _vm._e(), _vm.controlType == "table" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("操作"),
      prop: "operation"
    }
  }, [_c("a-radio-group", {
    staticStyle: {
      display: "flex",
      "flex-direction": "column"
    },
    model: {
      value: _vm.dataGroupForm.operation,
      callback: function ($$v) {
        _vm.$set(_vm.dataGroupForm, "operation", $$v);
      },
      expression: "dataGroupForm.operation"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "addEditDel"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加配件")) + "/" + _vm._s(_vm.$t("编辑")) + "/" + _vm._s(_vm.$t("删除")) + " ")]), _c("a-radio", {
    attrs: {
      value: "lossDetermination"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("定损意见")) + " ")]), _c("a-radio", {
    attrs: {
      value: "nuclearDamage"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("核损意见")) + " ")])], 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 4
      }
    }
  }, [_c("a-button", {
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")]), _c("a-button", {
    staticClass: "marginL15",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onGroupSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("确认")) + " ")])], 1)], 1) : _vm._e()], 1), _c("div", {
    staticClass: "rightBox"
  }, [_vm._l(_vm.controlList, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("top-title", {
      attrs: {
        background: true
      }
    }, [_c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.$t(item.controlTitle))), item.other == 1 ? _c("span", [_vm._v("(" + _vm._s(_vm.$t("可以添加多个")) + ")")]) : _vm._e()]), _c("div", {
      attrs: {
        slot: "btn"
      },
      slot: "btn"
    }, [_c("a-icon", {
      staticStyle: {
        cursor: "pointer"
      },
      attrs: {
        type: "close"
      },
      on: {
        click: function ($event) {
          return _vm.handleControlDel(index);
        }
      }
    })], 1)]), item.controlType != "table" ? _c("div", _vm._l(item.control, function (item2, index2) {
      return _c("div", {
        key: index2
      }, [_c("control-item", {
        attrs: {
          item2: item2
        }
      })], 1);
    }), 0) : _c("div", [_c("a-table", {
      staticClass: "marginT20",
      attrs: {
        bordered: "",
        columns: item.control,
        rowKey: "id",
        "data-source": []
      }
    }, _vm._l(item.control, function (item, i) {
      return _c("span", {
        key: i,
        attrs: {
          slot: item.slots.title
        },
        slot: item.slots.title
      }, [_vm._v(_vm._s(_vm.$t(item.slots.title)))]);
    }), 0)], 1)], 1);
  }), _vm.isEdit && _vm.controlType == "control" ? _c("div", {
    staticClass: "controlItem"
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.checked ? _c("span", [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.dataForm.controlName || _vm.$t("控件名称")) + ": "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.dataForm.controlExplain) + " ")]), _vm.dataForm.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2)], 1), _c("div", {
    staticClass: "contBox"
  }, [_vm.dataForm.partsType == "singleLine" ? _c("a-input", {
    attrs: {
      placeholder: _vm.$t(_vm.dataForm.promptText),
      readOnly: true
    }
  }) : _vm._e(), _vm.dataForm.partsType == "multiline" ? _c("a-textarea", {
    attrs: {
      placeholder: _vm.$t(_vm.dataForm.promptText),
      readOnly: true
    }
  }) : _vm._e(), _vm.dataForm.partsType == "singleChoice" ? _c("a-radio-group", {
    attrs: {
      disabled: ""
    }
  }, _vm._l(_vm.dataForm.optionList, function (item, index) {
    return _c("a-radio", {
      key: index,
      attrs: {
        value: item
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 1) : _vm._e(), _vm.dataForm.partsType == "multipleChoice" ? _c("a-checkbox-group", {
    attrs: {
      disabled: "",
      options: _vm.dataForm.optionList
    }
  }) : _vm._e(), _vm.dataForm.partsType == "dropDown" || _vm.dataForm.partsType == "hierarchy" && _vm.dataForm.type != "province" ? _c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t(_vm.dataForm.promptText)
    }
  }, _vm._l(_vm.dataForm.optionList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 1) : _vm._e(), _vm.dataForm.partsType == "hierarchy" && _vm.dataForm.type == "province" ? _c("area-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t(_vm.dataForm.promptText)
    }
  }) : _vm._e(), _vm.dataForm.partsType == "date" && _vm.dataForm.dateType == 1 || _vm.dataForm.partsType == "date" && !_vm.dataForm.dateType ? _c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      format: _vm.getFormatDate(),
      placeholder: _vm.$t(_vm.dataForm.promptText)
    }
  }) : _vm._e(), _vm.dataForm.partsType == "date" && _vm.dataForm.dateType == 3 ? _c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      format: _vm.getFormatDate() + "HH:mm" + _vm.dateChronaxie(),
      "show-time": "",
      placeholder: _vm.$t(_vm.dataForm.promptText)
    }
  }) : _vm._e(), _vm.dataForm.partsType == "dateRange" && _vm.dataForm.dateType == 1 || _vm.dataForm.partsType == "dateRange" && !_vm.dataForm.dateType ? _c("a-range-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      format: _vm.getFormatDate()
    }
  }) : _vm._e(), _vm.dataForm.partsType == "dateRange" && _vm.dataForm.dateType == 3 ? _c("a-range-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "show-time": {
        format: "HH:mm"
      },
      format: _vm.getFormatDate() + "HH:mm" + _vm.dateChronaxie()
    }
  }) : _vm._e(), _vm.dataForm.partsType == "picture" || _vm.dataForm.partsType == "enclosure" ? _c("div", {
    staticClass: "pictureBox"
  }, [_c("div", {
    staticClass: "ant-upload ant-upload-select ant-upload-select-picture-card picture"
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  })], 1), _vm.dataForm.fileFormat.length != 0 ? _c("div", [_vm._v(" *" + _vm._s(_vm.$t("文件格式")) + "（" + _vm._s(_vm.dataForm.fileFormat.join(",")) + "） ")]) : _vm._e(), _vm.dataForm.template.length != 0 ? _c("div", [_vm._v(_vm._s(_vm.$t("模板预览")))]) : _vm._e()]) : _vm._e()], 1)]) : _vm._e(), _vm.isEdit && _vm.controlType != "control" ? _c("div", [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t(_vm.dataGroupForm.controlTitle)))])]), _vm.isEdit && _vm.controlType == "controlGroup" ? _c("div", _vm._l(_vm.dataGroupForm.control, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("control-item", {
      attrs: {
        item2: item
      }
    })], 1);
  }), 0) : _vm._e(), _vm.controlType == "table" ? _c("div", [_c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.dataGroupForm.control,
      rowKey: "id",
      "data-source": []
    }
  }, _vm._l(_vm.dataGroupForm.control, function (item, i) {
    return _c("span", {
      key: i,
      attrs: {
        slot: item.slots.title
      },
      slot: item.slots.title
    }, [_vm._v(_vm._s(_vm.$t(item.slots.title)))]);
  }), 0)], 1) : _vm._e()], 1) : _vm._e()], 2), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["avi", "mov", "rm", "mp4", "rmvb"],
      fileList: _vm.dataForm.fileList,
      show: _vm.isShow,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };